// Shared "geometry by feature code" resolver: feed cache first, then the
// feature endpoint, with a module-level cache + in-flight dedupe so the
// Monitoring and Imagery tabs don't each maintain their own copy.
import { API, HOST } from '@/utils/http'
import { useGeoStore } from '@/stores/geo'

const cache = new Map()
const inflight = new Map()

export async function resolveFeatureGeometry(code) {
  if (!code) return null
  if (cache.has(code)) return cache.get(code)
  const feed = useGeoStore().feedFeatures?.features?.find(
    (f) => f.properties?.code === code
  )
  if (feed?.geometry) {
    cache.set(code, feed.geometry)
    return feed.geometry
  }
  if (inflight.has(code)) return inflight.get(code)
  const pending = API.get(`${HOST}/geo/feature/${code}`)
    .then(({ data }) => data?.geometry || null)
    .catch(() => null)
    .finally(() => inflight.delete(code))
  inflight.set(code, pending)
  const geometry = await pending
  if (geometry) cache.set(code, geometry)
  return geometry
}
